import CommentActionField from "./comment-action-field";

const CommentsFields = {
    Action: CommentActionField,
};

export default CommentsFields;
